import Base from '@studiometa/js-toolkit';
import Vue from 'vue';
import VueSearch from './Search';
import { isDev } from '../../config';

/**
 * Search Autocomplete
 */
export default class Search extends Base {
  /**
   * Component configuration
   */
  get config() {
    return {
      name: 'Search',
      log: isDev(),
    };
  }

  /**
   * @return {MenuMain} The MenuMain instance
   */
  get menuMain() {
    return this.$parent.$children?.MenuMain?.[0];
  }

  /**
   * Mounted hook
   */
  mounted() {
    this.isOpen = false;

    /**
     * Pass all data-options as props
     * @see block--em-main-search-autocomplete-block.html.twig
     */
    const props = {
      ...this.$options,
    };

    this.vue = new Vue({
      el: this.$refs.vue,
      data: () => ({
        isOpen: false,
      }),
      render(h) {
        return this.isOpen
          ? h(VueSearch, {
              props,
            })
          : '';
      },
    });

    window.addEventListener('scroll', this.close);
    window.addEventListener('resize', this.close);
  }

  /**
   * Btn Click Handle
   */
  onBtnClick() {
    this.toggle();
  }

  /**
   * Open
   */
  open() {
    this.vue.isOpen = true;

    this.$parent.$children.ProfilTopHeader[0].closeDropdown();

    if (this.menuMain) {
      this.menuMain.closeCurrentSubmenu();
    }

    this.$refs.searchIcon.classList.add('hidden');
    this.$refs.closeIcon.classList.remove('hidden');
    this.isOpen = true;
  }

  /**
   * Close
   */
  close() {
    this.vue.isOpen = false;
    this.$refs.searchIcon.classList.remove('hidden');
    this.$refs.closeIcon.classList.add('hidden');
    this.isOpen = false;
  }

  /**
   * Toggle
   */
  toggle() {
    return this.isOpen ? this.close() : this.open();
  }

  /**
   * Destroy hook
   */
  destroyed() {
    this.vue.$destroy(true);
    window.removeEventListener('scroll', this.close);
    window.removeEventListener('resize', this.close);
  }
}
